module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capitolo tre")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il sergente Windflower deglutì rumorosamente alcuni sorsi di tè, salutò Sheila e si lanciò sulla sua auto di pattuglia lasciandosi dietro una scia di brezza fresca e bollenti pettegolezzi. Sheila lo seguì con lo sguardo mentre usciva, ammirando non solo il taglio della sua uniforme ma anche la sua postura alta, orgogliosa ed eretta mentre metteva in moto l'automobile e partiva. Dal canto suo, Windflower stava ancora sorridendo per il caloroso benvenuto che Sheila Hillier gli aveva dato porgendogli il tè quella mattina.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sheila era una rossa dal carattere impetuoso, nata e cresciuta a Terranova, che aveva avviato il Mug-Up dopo l'improvvisa perdita del marito in un incidente con delle attrezzature pesanti a Fort McMurray. Forse era stato il suo legame con il nord Alberta che lo aveva attratto all'inizio. No, decisamente erano le sue gambe lunghe e lisce, e la sua sensualità delicata e onesta. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Che donna")]), _vm._v(", pensò. Ma non poteva lasciarsi andare, almeno non ancora.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Si fermò nell'angusto parcheggio della clinica di Grand Bank e si mosse rapidamente per uscire dalla coltre di nebbia isolante che presto avrebbe avvolto l'intera penisola. Fece un cenno a Tizzard che era seduto nella sala d’attesa e chiacchierava con la receptionist, Betty Halliday, la quale non aspettava altro che farsi ammaliare dal fascino di uomo in uniforme, qualsiasi uniforme.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«È con qualcuno Sarge», disse Tizzard, arrossendo lievemente alla vista del suo superiore, ma riuscì comunque a indirizzare un sorriso sornione a Betty Halliday, le cui gote si illuminarono di rosa più che mai.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Proprio in quel momento il dott. Vinjay Sanjay uscì dal suo ufficio, le braccia intorno alle spalle di un paziente anziano che probabilmente aveva bisogno di compagnia più che di cure mediche.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Buongiorno sergente Windflower», disse il dottore basso, occhialuto e leggermente curvo. «Come "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("buttano")]), _vm._v(" le cose?» chiese ridendo.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Windflower rise della combinazione di formalità indiana e gergo Newfie appena acquisito. Rispose come faceva sempre con «Fantastico, come sta il mio indiano preferito della costa meridionale?» Entrambi gli uomini risero di nuovo della loro consueta battuta.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Vieni dentro, vieni dentro», disse il dott. Sanjay, rendendosi conto che il momento di scherzare era finito.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Allora cosa abbiamo?» chiese Windflower non appena la porta si chiuse.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Beh, come stavo spiegando al tuo agente qui presente, non c’era alcun segno esteriore di trauma sul corpo e la maggior parte della gente del posto potrebbe essere perdonata per aver pensato che questo tizio sia morto per un attacco di cuore. In effetti, ha avuto una grave insufficienza coronarica. Ma quando ho esaminato il sig. Martin ho notato alcune anomalie che normalmente non si riscontrano in un infarto acuto.»")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Cosa vuoi dire, Doc?» chiese Windflower.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Beh, vieni con me e te lo mostrerò,» rispose il dottore.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Condusse Windflower e il sorprendentemente silenzioso Tizzard in una piccola stanza refrigerata sul retro che fungeva da obitorio improvvisato per la clinica. Tirò indietro il lenzuolo che copriva i resti di Elias Martin, ormai ingrigito e irrigidito dal rigor mortis. Sia Windflower che Tizzard furono sorpresi dall’odore acre e stucchevole della morte, ma il dott. Sanjay sembrava completamente indifferente a ciò che lo circondava.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "18",
      "src": "d2d_images/image067.png",
      "width": "23"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Vedi qui, sergente, quando tiro le unghie di quest’uomo si staccano completamente ed è lo stesso con le unghie dei piedi. Di solito sarebbero rimaste saldamente attaccate al defunto. E i capelli si strappano a ciocche», disse, stringendo nella mano un pugno di quelli del defunto. «Mi è parso strano, quindi, ieri sera, ho inviato in taxi un campione di capelli e sangue a un amico del laboratorio di St. John’s e mi hanno richiamato appena prima che arrivasse l’agente Tizzard».")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Quindi, di cosa si tratta?» chiese Windflower.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«È stato avvelenato, Sarge», sbottò Tizzard, incapace di trattenersi oltre.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«È vero Doc? avvelenato? Potrebbe essere stato un incidente?»")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Poco probabile. Altrimenti, la mia sala d’attesa sarebbe piena di persone avvelenate. Per quanto sembri strano, sergente, quest’uomo è morto per via di una grave insufficienza coronarica che pare direttamente collegata a un avvelenamento acuto da arsenico. Personalmente non ho mai visto un caso come questo prima, ma le prove sembrano piuttosto chiare. Elias Martin è morto per causa diretta di un avvelenamento da arsenico e data la quantità presente nel suo corpo, gli è stato probabilmente somministrato per lungo tempo. Come ci sia arrivato non ne ho idea. Ma immagino che questo sia il tuo lavoro, sergente Windflower».")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Credo proprio di sì», ponderò sommessamente tra sé e sé.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0